<template>
    <div>
        <router-view v-show="$route.meta.hasOwnProperty('detail') && $route.meta.detail"></router-view>
        <div class="wrap" v-show="!$route.meta.hasOwnProperty('detail') || !$route.meta.detail">
            <div class="container lnb">
                <div class="contents_wrap">
                    <div class="contents">
                        <div class="title">
                            {{ title }}
                            <el-button class="title_btn" type="primary" @click="$router.push('/suggest/word/create')">
                                등록
                            </el-button>
                            <div class="clear"></div>
                        </div>
                        <suggest-list-component :suggestType="'word'"></suggest-list-component>
                    </div>
                    <page-footer></page-footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SuggestListComponent from "@/components/suggest/SuggestListComponent";

export default {
    name: "SuggestWord",
    mixins: [],
    components: {SuggestListComponent},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            title: this.$route.meta.title,
        }
    },
    beforeRouterEnter() {},
    created() {},
    mounted() {},
    beforeDestroy() {},
    destroyed() {},
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
